// src/app/services/gtm.service.ts
import { isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GtmService {
    public selectPackageReferrer: string;

    // Vars
    public registerPageReferrer: string;
    public confirmOrderReferrer: string;
    public dashboardReferrer: string;
    public allRicaDocumentsUploaded: boolean;
    // -- Hashes
    public reg_emailHash: string;
    public reg_phoneHash: string;


    public forgotPasswordPageReferrer: string;


    constructor(
        @Inject(PLATFORM_ID) private platformId: any,

    ) {
    }

    public initGtm() {
        if (isPlatformBrowser(this.platformId)) { 
            const gtmId = environment.googleAnalyticsCode;
            if (gtmId && !document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`)) {
                const script = document.createElement('script');

                script.innerHTML = `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${gtmId}');`;
                document.head.appendChild(script);

                // Optional: Add <noscript> fallback manually
                const noscript = document.createElement('noscript');
                noscript.innerHTML = `
                        <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
                        height="0" width="0" style="display:none;visibility:hidden"></iframe>
                    `;
                document.body.appendChild(noscript);
            }
        }
    }

    public pushEvent(data: any) {
        if (isPlatformBrowser(this.platformId)) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ...data });
        }
    }

}
